import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Slide,
  Alert,
} from "@mui/material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

export default function ConfirmDialog({ open, onClose, onSubmit, title, alertDescription, description, submitButton }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      slots={{
        transition: Transition,
      }}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {alertDescription && (
          <Alert sx={{ mb: 2 }} severity="warning">
            {alertDescription}
          </Alert>
        )}
        <DialogContentText sx={{ whiteSpace: "pre-line" }}>{description}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color={"secondary"}>
          Zrušit
        </Button>
        <Button onClick={onSubmit} color={submitButton.color}>
          {submitButton.label}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
